import * as styles from './SuperAgentBadge.css';
import { Image, Label } from '@cian/ui-kit';
import starSvg from './icons/star.svg';

export type TSuperAgentBadgeProps = {
  levelName: string;
};

export const SuperAgentBadge = ({ levelName }: TSuperAgentBadgeProps) => {
  return (
    <div className={styles['wrapper']}>
      <Label
        data-testid={'badgeSuperAgent'}
        icon={<Image src={starSvg} height={16} width={16} />}
        background="#EBF9E6"
        color="#34ac0a"
      >
        {levelName}
      </Label>
    </div>
  );
};
